<template>
  <div class="text-center">
    <v-menu offset-y :close-on-content-click="false" v-model="menuOpen">
      <template v-slot:activator="{ on }">
        <span v-on="on" class="cursor-pointer">
          <v-icon x-small>fa fa-ellipsis-h</v-icon>
        </span>
      </template>
      <v-list dense>
        <v-list-item v-for="(item, index) in getItems" :key="index">
          <v-list-item-content v-if="item.code == 'E'" class="pt-0 pb-0 list-item-parnert">
            <v-btn small text @click="okEvent($event, item.code)">
              {{ item.content }}
              <v-spacer></v-spacer>
            </v-btn>
          </v-list-item-content>
          <v-list-item-content v-else-if="item.code == 'D'" class="pt-0 pb-0 list-item-parnert">
            <v-tooltip top :disabled="getDataValue.numOfUse == 0">
              <template v-slot:activator="{on}">
                <div v-on="on" class="btn-tooltip">
                  <dialogWindow
                    :btnTxt="item.content"
                    :info="getDataValue.prnrNm"
                    :detail="$t('msg.partners.deletePartner')"
                    :dataValue="getDataValue"
                    :showCancel="true"
                    :customDisable="getDataValue.numOfUse > 0"
                    @select-ok="deletePartner($event, item.code)"
                    color="confirmation"
                    title="Delete Partner"
                    size="max"
                  ></dialogWindow>
                </div>
              </template>
              <span v-html="$t('lbl.processSetup.partnerCardWF')"></span>
            </v-tooltip> 
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>


<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue'

export default {
  components: {
    dialogWindow,
  },
  props: {
    items: {
      default: [
        { content: 'Edit...', code: "E" },
        { content: 'Delete this partner', code: "D"  },
      ]
    },
    dataValue: {
      default: {},
    },
  },
  data() {
    return {
      menuOpen: false
    }
  },
  computed: {
      getItems() {
          return this.items;
      },
      getDataValue() {
        return this.dataValue;
      }
  },
  methods: {
      deletePartner(item, code) {
        if(code == 'D') {
          this.menuOpen = false;
          this.$store.dispatch('deletePartner', item).then(() => {
            this.$emit('refresh');
          });
        }
      },

      okEvent(item, code) {
        if(code == 'E') {
          let result = Object;
          result.value = item;
          result.code = code;
          this.$emit("click-event", result);
          this.menuOpen = false;
        }
      }
  },
}
</script>

<style>
.width-400 {
  width: 200px;
}
.theme--light .v-list-item .list-item-parnert span.v-btn__content{
  color: #000000;
}
.theme--light .partner-card-container a , .theme--light .partner-card-container .far.fa-envelope{
   color: #2C89B9;
}
</style>